import { Button, Group, Stack, Text } from '@mantine/core';
import { mergeWith } from 'lodash';
import { useState } from 'react';

import { TSDListItem } from '@e-origin/contracts';

import { useUpdateTSD } from '@hooks/tsd';

interface AmendTSDProps {
  tsd: TSDListItem;
  onHide(): void;
  onNavigate(): void;
}

export const AmendTSD: React.FC<AmendTSDProps> = ({ onHide, onNavigate, tsd }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateTSDMutation = useUpdateTSD();

  const handleAmend = async () => {
    setLoading(true);
    setError(null);
    try {
      updateTSDMutation.mutate({
        tsd: mergeWith(
          { _id: tsd._id, name: tsd.name },
          {
            customer: tsd.customer,
            generalInfo: {
              ...tsd.generalInfo,
              isAmended: true,
            },
          },
        ),
        refreshCustomerData: false,
      });
      onHide();
    } catch (e: any) {
      setError(e?.message || 'An error occurred');
    } finally {
      setLoading(false);
      if (!error) onNavigate();
    }
  };

  return (
    <Stack>
      <Text>Are you sure you want to amend this temporary storage? This action cannot be undone!</Text>
      {error && <Text c="red">{error}</Text>}
      <Group justify="center" mt="xl">
        <Button type="button" onClick={onHide} disabled={loading} variant="transparent">
          Cancel
        </Button>
        <Button type="button" onClick={handleAmend} loading={loading} color="red" data-pw="amend-btn">
          Amend
        </Button>
      </Group>
    </Stack>
  );
};
